import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-4 pb-7 sm:pt-12 sm:pb-20 items-center justify-center bg-bg-main overflow-hidden" data-id="element-248">
      {/* Background Glow — uses radial gradient instead of blur for performance */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(249,115,22,0.18) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-249"></div>

      {/* Attention Badge */}
      <div className="relative bg-badge-red/10 border border-badge-red/20 text-badge-red font-bold text-[10px] sm:text-xs px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-3 sm:mb-6 flex items-center gap-1.5 sm:gap-2" data-id="element-250">
        <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-badge-red animate-pulse-composited" data-id="element-251"></span>
        <span className="hidden sm:inline" data-id="element-252">
          ATTENZIONE: INSEGNANTI DI SCUOLA PRIMARIA STANCHE DI SACRIFICARE LE
          PROPRIE SERATE A PIANIFICARE
        </span>
        <span className="sm:hidden" data-id="element-253">
          ATTENZIONE: INSEGNANTI DI SCUOLA PRIMARIA
        </span>
      </div>

      {/* Main headline */}
      <h1 className="relative font-black text-text-main max-w-5xl sm:text-5xl md:text-7xl leading-[1.1] sm:leading-[1.05] mb-3 sm:mb-6 tracking-tight text-[26px]" data-id="element-254">
        Pianifica un{' '}
        <span className="relative inline-block" data-id="element-255">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-300 via-primary to-orange-500" data-id="element-256">
            intero anno
          </span>
          <svg className="absolute -bottom-1 sm:-bottom-2 left-0 w-full" viewBox="0 0 200 8" preserveAspectRatio="none" aria-hidden="true" data-id="element-257">
            <path d="M2 5 Q 50 1, 100 4 T 198 3" stroke="url(#underline-gradient)" strokeWidth="2.5" fill="none" strokeLinecap="round" data-id="element-258" />
            <defs data-id="element-259">
              <linearGradient id="underline-gradient" x1="0" x2="1" y1="0" y2="0" data-id="element-260">
                <stop offset="0%" stopColor="#fdba74" data-id="element-261" />
                <stop offset="100%" stopColor="#f97316" data-id="element-262" />
              </linearGradient>
            </defs>
          </svg>
        </span>{' '}
        di{' '}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-orange-400" data-id="element-263">
          Arte e Immagine
        </span>
        <br className="hidden sm:block" data-id="element-264" /> in{' '}
        <span className="text-cta-green" data-id="element-265">soli 5 minuti</span>.
      </h1>

      {/* Subheadline */}
      <p className="relative text-text-sec text-[14px] sm:text-xl font-medium leading-snug mb-4 sm:mb-8 max-w-3xl mx-auto" data-id="element-266">
        Il primo Kit{' '}
        <span className="text-orange-400 font-bold" data-id="element-267">"Apri e Insegna"</span> con{' '}
        <span className="text-text-main font-bold" data-id="element-268">50 laboratori pronti</span>{' '}
        dalla 1ª alla 5ª classe.{' '}
        <span className="text-text-main font-semibold" data-id="element-269">
          Recupera i tuoi weekend.
        </span>
      </p>

      {/* Mockup image */}
      <div className="relative w-full max-w-[280px] sm:max-w-[440px] md:max-w-[520px] mx-auto mb-3.5 sm:mb-8" data-id="element-270">
        <div className="absolute inset-0 rounded-full pointer-events-none" style={{
        background: 'radial-gradient(circle, rgba(251,191,36,0.18) 0%, transparent 70%)'
      }} aria-hidden="true" data-id="element-271"></div>
        <img src="https://cdn.magicpatterns.com/uploads/nFVwinFPkqSYzo3B3f8gJQ/15002B_CLIENTE_SODDISFATTI_(7).png" alt="Arte Pronta — Kit Didattico Completo" className="relative w-full h-auto object-contain" width={520} height={520} sizes="(max-width: 640px) 280px, (max-width: 768px) 440px, 520px" fetchPriority="high" data-id="element-272" />
      </div>

      {/* Stars + Urgency */}
      <div className="relative flex flex-col items-center gap-1.5 sm:gap-2 mb-3.5 sm:mb-6" data-id="element-273">
        <div className="flex items-center gap-2" data-id="element-274">
          <span className="text-secondary text-sm sm:text-lg" data-id="element-275">⭐⭐⭐⭐⭐</span>
          <span className="text-text-sec text-xs sm:text-base font-medium" data-id="element-276">
            4.9/5 (+500 Recensioni Verificate)
          </span>
        </div>
        <span className="text-secondary font-bold text-xs sm:text-sm bg-secondary/10 px-3 py-1 rounded-full border border-secondary/20" data-id="element-277">
          🔥 47 insegnanti hanno scelto questo Kit oggi
        </span>
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="group relative btn-primary-pulse bg-cta-green hover:bg-cta-green-hover transition-all duration-200 hover:scale-[1.02] active:scale-[0.99] inline-flex items-center justify-center gap-2 px-6 sm:px-12 py-4 sm:py-5 rounded-2xl mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white shadow-[0_4px_12px_rgba(0,0,0,0.25)]" data-id="element-278">
        <span className="flex items-center justify-center gap-2 font-black text-[16px] sm:text-2xl leading-tight text-center" data-id="element-279">
          🚀 SÌ! VOGLIO RECUPERARE IL MIO TEMPO
        </span>
      </a>

      {/* Trust badges */}
      <p className="relative text-text-sec text-[11px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-2 flex-wrap" data-id="element-280">
        <span data-id="element-281">⚡ Accesso Immediato</span>
        <span data-id="element-282">•</span>
        <span data-id="element-283">🛡️ Garanzia 7 Giorni</span>
        <span data-id="element-284">•</span>
        <span data-id="element-285">💳 Pagamento Unico</span>
      </p>
    </section>;
}